<fa-icon icon="{{ getIconName() }}" aria-hidden="true"></fa-icon>
